import { useState } from "react";
import { Dialog } from './dialog';
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";

interface GroomSessionsDialogProps {
    visible: boolean;
    onClose: () => void;
    onDeleted: (payload: { mode: string; days: number }) => Promise<void>;
}

export function GroomSessionsDialog({
    visible,
    onClose,
    onDeleted
}: GroomSessionsDialogProps) {
    const [mode, setMode] = useState<"empty" | "all">("empty");
    const [days, setDays] = useState<number>(100);

    const modeOptions = [
        { label: "Empty sessions", value: "empty" },
        { label: "All sessions", value: "all" }
    ];

    const handleDelete = () => {
        onDeleted({ mode, days });
        onClose();
    };

    return (
        <Dialog
            header="Groom user sessions"
            visible={visible}
            onHide={onClose}
            style={{ width: "400px" }}
            modal
        >
            <div className="flex flex-column gap-4">

                {/* Mode dropdown */}
                <div className="flex flex-column gap-2">
                    <label className="font-medium">Mode</label>
                    <Dropdown
                        value={mode}
                        options={modeOptions}
                        onChange={(e) => setMode(e.value)}
                        className="w-full"
                        scrollHeight={'500px'}
                    />
                </div>

                {/* Older Than input */}
                <div className="flex flex-column gap-2">
                    <label className="font-medium">Older than (days)</label>
                    <InputNumber
                        value={days}
                        onValueChange={(e) => setDays(e.value ?? 100)}
                        min={1}
                        showButtons
                        className="w-full"
                    />
                </div>

                {/* Footer buttons */}
                <div className="flex justify-content-end gap-2 pt-3">
                    <Button
                        label="Cancel"
                        severity="secondary"
                        icon="pi pi-times"
                        onClick={onClose}
                    />
                    <Button
                        label="Delete"
                        severity="danger"
                        icon="pi pi-trash"
                        onClick={handleDelete}
                    />
                </div>
            </div>
        </Dialog>
    );
}